import { useStore } from '../store'

export interface Scope {
  getters?: string[]
  state?: string[]
  dispatch?: string[]
  commit?: string[]
}

interface StoreConfig {
  dispatch: (type: string, payload?: any) => any
  getters: any
  state: any
  commit: (type: string, payload?: any) => any
}

export const useScopedStore = (scope?: Scope) => {

  const store: any = useStore()
  const config: StoreConfig = {
    dispatch: getDispatcher,
    getters: {},
    state: {},
    commit: getCommitter,
  }

  function getDispatcher(type: string, payload?: any) {
    if (scope?.dispatch?.includes(type)) {
      return store.dispatch(type, payload)
    }
    return new Error('Dispatch Not allowed')
  }

  function getCommitter(type: string, payload?: any) {
    if (scope?.commit?.includes(type)) {
      return store.commit(type, payload)
    }
    return new Error('Commit Not Allowed')
  }
  
  for (const key of scope?.state ?? []) {
    config.state[key] = store.state[key]
  }

  for (const key of scope?.getters ?? []) {
    config.getters[key] = store.getters[key]
  }

  return config
}
